import Reflux from 'reflux';
import ItemSetData from 'shared/data/ItemSet';
import ShowData from 'shared/data/Show';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';
import Promise from 'bluebird';

const async = { asyncResult: true };

const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);
const readOnlyCfg = readOnlyHelper.actionConfigFactory();

const CuesheetRowActions = Reflux.createActions({
  showProofHistory: {},
  hideProofHistory: {},
  loadProofHistory: asyncReadOnlyCfg,
  clearProofHistory: {},
  updateRowHighlight: readOnlyCfg,
  toggleRowHighlight: readOnlyCfg,
  updateRowPersonalHighlight: readOnlyCfg,
  toggleRowPersonalHighlight: readOnlyCfg,
  moveItemRowDown: readOnlyCfg,
  moveItemRowUp: readOnlyCfg,
  addTitleRowAbove: readOnlyCfg,
  addTitleRowBelow: readOnlyCfg,
  convertToTitleRow: readOnlyCfg,
  convertToStandardRow: readOnlyCfg,
  toggleTitleRow: readOnlyCfg,
  addGlobalElementItemRowBelow: readOnlyCfg,
  addGlobalElementItemRowsPersistent: asyncReadOnlyCfg,
  addGlobalElementItemRowsTransient: { sync: true },
  addItemRowAbove: readOnlyCfg,
  addItemRowBelow: readOnlyCfg,
  addItemRowProof: readOnlyCfg,
  updateItemRowProofNote: readOnlyCfg,
  clearItemRowProof: readOnlyCfg,
  duplicateItemRow: readOnlyCfg,
  deleteItemRowTransient: {},
  deleteItemRow: readOnlyCfg,
  deletedSelectedRows: readOnlyCfg,
  restoreItemRow: readOnlyCfg,
  addRowToPasteBuffer: {},
  addRowToCutBuffer: readOnlyCfg,
  addSelectionToPasteBuffer: {},
  addSelectionToCutBuffer: readOnlyCfg,
  clearRowSelection: {},
  pasteBufferAbove: readOnlyCfg,
  pasteBufferBelow: readOnlyCfg,
  toggleRowSelection: {},
  toggleMultipleRowSelection: {},
  toggleRowLock: readOnlyCfg,
  selectAllRows: {},
  trackRow: readOnlyCfg,
  trackNextRow: readOnlyCfg,
  trackPreviousRow: readOnlyCfg,
  trackSelectedRow: readOnlyCfg,
  trackRowTransient: readOnlyCfg,
  clearTrackedRowTransient: readOnlyCfg,
  scrollToRow: {},
  addItemRow: readOnlyCfg,
  addItemRowsPersistent: asyncReadOnlyCfg,
  convertToTitleRowPersistent: asyncReadOnlyCfg,
  convertToStandardRowPersistent: asyncReadOnlyCfg,
  moveFromTo: { sync: true },
  moveFromToPersistent: asyncReadOnlyCfg,
  moveRows: { sync: true },
  //Notification that a move delta is being persisted (the GEM stores mirror
  //their local order copies from it). Deliberately NOT named *Persistent:
  //CuesheetRowMixin makes the request itself so it can tie each settlement
  //back to its dispatch by identity — binding listenAndPromise to this
  //action would issue every move request twice.
  rowsMovedLocally: readOnlyCfg,
  //Notification that a settled moveRows response re-synced the cuesheet to the
  //server's authoritative order (which may have merged in a concurrent remote
  //move). The GEM stores listen so they don't keep the stale optimistic order
  //they applied via rowsMovedLocally — they never receive this HTTP response
  //themselves.
  rowOrderResynced: readOnlyCfg,
  deleteItemRowPersistent: asyncReadOnlyCfg,
  deleteItemRowsPersistent: asyncReadOnlyCfg,
  restoreItemRowPersistent: asyncReadOnlyCfg,
  updateItemRowPersistent: asyncReadOnlyCfg,
  updateItemRowSettingsPersistent: asyncReadOnlyCfg,
  updateItemRowUserSettingsPersistent: asyncReadOnlyCfg,
  addItemRowProofPersistent: asyncReadOnlyCfg,
  updateItemRowProofNotePersistent: asyncReadOnlyCfg,
  clearItemRowProofPersistent: asyncReadOnlyCfg,
  clearProofHistoryPersistent: asyncReadOnlyCfg,
  bustRowHeightCache: { sync: true },
  updateRow: readOnlyCfg,
  updateRowPersistent: asyncReadOnlyCfg,
  clearGlobalElementManagerRowsFilter: { sync: true },
  filterGlobalElementManagerRows: { sync: true },
  filterGlobalElementManagerRowsOnLoad: { sync: true },
  retrieveLatestGlobalElementVersion: { sync: true },
  retrieveLatestGlobalElementVersionPersistent: asyncReadOnlyCfg,
  retrieveLatestGlobalElementVersionForSelectedRow: { sync: true },
  publishSelectedShowRowChangesEverywhere: { sync: true },
  publishShowRowChangesToGlobalElementRow: { sync: true },
  publishAllShowRowChangesToGlobalElementManager: { sync: true },
  publishAllShowRowChangesToGlobalElementManagerPersistent: asyncReadOnlyCfg,
  publishSelectedShowRowChangesToGlobalElementRow: { sync: true },
  publishShowRowChangesToGlobalElementRowPersistent: asyncReadOnlyCfg,
  removeGlobalElementReference: { sync: true },
  removeGlobalElementReferencePersistent: asyncReadOnlyCfg,
  refreshGlobalElementRowAssociations: asyncReadOnlyCfg,
  handleDeleteRowWithConfirmation: {},
  deleteSelectedRowsWithConfirmation: {},
  saveSelectionAsNewGlobalElements: {},
});

CuesheetRowActions.refreshGlobalElementRowAssociations.listenAndPromise(
  ShowData.getGlobalElementShowItems,
);

CuesheetRowActions.moveFromToPersistent.listenAndPromise(
  ItemSetData.moveFromTo,
);

CuesheetRowActions.addItemRowProofPersistent.listenAndPromise(
  ItemSetData.createProofOfPerformance,
);
CuesheetRowActions.updateItemRowProofNotePersistent.listenAndPromise(
  ItemSetData.updateProofOfPerformanceNote,
);
CuesheetRowActions.clearItemRowProofPersistent.listenAndPromise(
  ItemSetData.clearProofOfPerformance,
);
CuesheetRowActions.loadProofHistory.listenAndPromise(
  ItemSetData.getItemRowProofHistory,
);
CuesheetRowActions.clearProofHistoryPersistent.listenAndPromise(
  ItemSetData.clearProofOfPerformanceHistory,
);

CuesheetRowActions.addItemRowsPersistent.listenAndPromise(
  ItemSetData.createItemRows,
);
CuesheetRowActions.deleteItemRowPersistent.listenAndPromise(
  ItemSetData.softDeleteItemRow,
);
CuesheetRowActions.deleteItemRowsPersistent.listenAndPromise(
  ItemSetData.softDeleteItemRows,
);
CuesheetRowActions.restoreItemRowPersistent.listenAndPromise(
  ItemSetData.restoreItemRow,
);
CuesheetRowActions.updateItemRowPersistent.listenAndPromise(
  ItemSetData.updateItemRow,
);
CuesheetRowActions.updateItemRowSettingsPersistent.listenAndPromise(
  ItemSetData.updateItemRowSettings,
);
CuesheetRowActions.updateItemRowUserSettingsPersistent.listenAndPromise(
  ItemSetData.updateItemRowUserSettings,
);
CuesheetRowActions.addGlobalElementItemRowsPersistent.listenAndPromise(
  ItemSetData.createGlobalElementItemRows,
);
CuesheetRowActions.retrieveLatestGlobalElementVersionPersistent.listenAndPromise(
  ItemSetData.retrieveLatestGlobalElementVersion,
);
CuesheetRowActions.publishShowRowChangesToGlobalElementRowPersistent.listenAndPromise(
  ItemSetData.publishShowRowChangesToGlobalElementRow,
);
CuesheetRowActions.removeGlobalElementReferencePersistent.listenAndPromise(
  ItemSetData.removeGlobalElementReference,
);

CuesheetRowActions.convertToTitleRowPersistent.listenAndPromise(
  ItemSetData.convertToTitleRow,
);
CuesheetRowActions.updateRowPersistent.listenAndPromise(
  ItemSetData.updateRowLabels,
);
CuesheetRowActions.convertToStandardRowPersistent.listenAndPromise(
  ItemSetData.convertToStandardRow,
);

CuesheetRowActions.publishAllShowRowChangesToGlobalElementManagerPersistent.listenAndPromise(
  (teamId, eventId, showId, itemSetListId, itemSetId, rowIds) => {
    return Promise.resolve(rowIds).mapSeries((rowId) => {
      return ItemSetData.publishShowRowChangesToGlobalElementRow(
        teamId,
        eventId,
        showId,
        itemSetListId,
        itemSetId,
        rowId,
      );
    });
  },
);

export default CuesheetRowActions;
